/* Наявність товарів для конструктора і квізу. 24.09.2026.
   Правило власника: товар, якого немає в наявності, прибираємо з усіх місць,
   де він використовується, а не показуємо недоступним.
   Джерело: /products.json магазину (увесь каталог одним запитом, 53 товари).
   Відповідь кешується в sessionStorage на 10 хвилин, тому на наступних
   сторінках перевірка миттєва. Якщо запит не вдався, нічого не ховаємо:
   краще показати товар, ніж зламати сторінку.

   AdaptisStock.ready: Promise, коли наявність відома.
   AdaptisStock.out(id): true, якщо варіант є в каталозі і його немає в наявності.
   AdaptisStock.prune(cfg): прибирає з даних конструктора (window.ADAPTIS_CONFIG)
   варіанти, позиції, тарифи й кольори з відсутніми товарами.
   AdaptisStock.syncImages(cfg): 26.09.2026, фото з того самого каталогу. У даних
   конструктора імена файлів записані під час перенесення прототипу, і після
   заміни фото в адмінці сторінки показували старі. Тепер фото позиції це фото
   її варіанта, а якщо його немає, головне фото товару; галерея сторінки
   термінала це фото самого товару. Кольори корпусу беруть фото варіанта лише
   тоді, коли його призначено в адмінці (зараз усі кольори ведуть на біле фото).
   Записане в даних ім'я файлу лишається запасним.
   AdaptisStock.syncPrices(cfg): 28.09.2026, ціни з того самого каталогу. Ціни
   в Shopify веде Adaptis Hub, а в даних конструктора вони записані вручну під
   час перенесення прототипу. Коли ціна в Shopify змінювалась, список товарів,
   вікно «Додано в кошик» і кошик показували нову, а сторінка товару стару.
   Тепер ціна кожної позиції з variant, кожної клітинки наборів (price і
   variant за призначенням і кольором) і пари [variant, ціна] корпусу береться
   з каталогу, зокрема ціни для Сил оборони (це окремі варіанти в Shopify).
   Стара ціна (compare) лишається, лише коли в каталозі вона більша за ціну.
   Записана в даних ціна лишається запасною. syncImages викликає і її, тому
   конструктор і квіз отримують ціни там само, де фото. */
(function(){
  "use strict";
  if (window.AdaptisStock) return;
  var KEY = "adaptis-stock-v3", TTL = 10 * 60 * 1000;
  var sold = {}, known = false;
  /* img: варіант → файл фото; own: у варіанта власне фото; pm: товар → усі
     фото; vp: варіант → товар. Файл без домену, як у даних конструктора.
     pr: варіант → [ціна, стара ціна] у копійках. */
  var img = {}, own = {}, pm = {}, vp = {}, pr = {};
  function fileOf(src){
    var m = /\/files\/([^\/]+)$/.exec(String(src || ""));
    return m ? m[1] : "";
  }

  /* Сторінка дає копійки ("p", "c"), /products.json гривні рядком ("23999.00"). */
  function kop(x){ var n = Math.round(parseFloat(x) * 100); return n > 0 ? n : 0; }
  function fill(list, keep){
    if (!keep){ sold = {}; img = {}; own = {}; pm = {}; vp = {}; pr = {}; }
    (list || []).forEach(function(p){
      var all = (p.images || []).map(function(x){ return fileOf(x.src); }).filter(Boolean);
      pm[p.id] = all;
      (p.variants || []).forEach(function(v){
        if (!v.available) sold[v.id] = true;
        var vf = fileOf(v.featured_image && v.featured_image.src);
        if (vf) own[v.id] = 1;
        if (vf || all[0]) img[v.id] = vf || all[0];
        vp[v.id] = p.id;
        if (typeof v.p === "number" && v.p > 0) pr[v.id] = [v.p, v.c > 0 ? v.c : 0];
        else if (v.price != null && kop(v.price) > 0) pr[v.id] = [kop(v.price), v.compare_at_price ? kop(v.compare_at_price) : 0];
      });
    });
    known = true;
  }
  function load(c){
    sold = c.s || {}; img = c.i || {}; own = c.o || {}; pm = c.m || {}; vp = c.v || {}; pr = c.p || {};
    known = true;
  }
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"; }

  /* 07.10.2026 (власник): ціни лише з товарів Shopify. Приховані (unlisted) товари не потрапляють
     ні в collections.all, ні в /products.json, тому їх дочитуємо за адресою товару. Список: адреса
     товару і його варіант (за ним видно, чи товар уже прийшов разом зі сторінкою). */
  var EXTRA = {
    "service-electrical-installation": 67623912505619,
    "12-56v-power-supply-starlink-standard": 67623917093139,
    "inverter-450-900w-dc-ac-starlink-standard": 67623924236563,
    "starlink-installation-on-site": 51790859436307,
    /* 09.10.2026 (власник: ціни ведення всюди з каталогу): тарифи з супроводом Adaptis теж приховані товари. Без них
       сторінка товару й квіз показували записану в даних ціну (6 078 ₴ на місяць за «Мандрівний»), а кошик справжню (7 000 ₴). */
    "roam-unlim-starlink-account-management": 54076760883475,
    "residential-unlimited-abonplata": 54636604490003,
    "starlink-global-priority-500-gb-plan": 54638566998291
  };
  function save(){
    try { sessionStorage.setItem(KEY, JSON.stringify({t:Date.now(), s:sold, i:img, o:own, m:pm, v:vp, p:pr})); } catch (e) {}
  }
  function extras(){
    var miss = Object.keys(EXTRA).filter(function(h){ return !(EXTRA[h] in vp); });
    if (!known || !miss.length) return Promise.resolve();
    return Promise.all(miss.map(function(h){
      return fetch(root() + "products/" + h + ".js", {headers:{Accept:"application/json"}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(list){
      /* /products/<handle>.js: фото рядками, ціна вже в копійках. */
      var add = list.filter(Boolean).map(function(p){
        return {id:p.id, images:(p.images || []).map(function(x){ return {src:x}; }),
          variants:(p.variants || []).map(function(v){
            return {id:v.id, available:v.available, p:v.price, c:v.compare_at_price || 0, featured_image:v.featured_image};
          })};
      });
      if (add.length){ fill(add, true); save(); }
    });
  }

  var ready = (function(){ return base().then(extras); })();
  function base(){
    /* 27.09.2026: дані з самої сторінки (snippets/adaptis-stock-boot.liquid),
       без окремого запиту й повторного малювання. */
    var boot = window.ADAPTIS_STOCK_BOOT;
    if (Array.isArray(boot) && boot.length){
      fill(boot);
      try { sessionStorage.setItem(KEY, JSON.stringify({t:Date.now(), s:sold, i:img, o:own, m:pm, v:vp, p:pr})); } catch (e) {}
      return Promise.resolve();
    }
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || "null");
      if (c && Date.now() - c.t < TTL){ load(c); return Promise.resolve(); }
    } catch (e) {}
    return fetch(root() + "products.json?limit=250", {headers:{Accept:"application/json"}})
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){
        fill(d.products);
        try { sessionStorage.setItem(KEY, JSON.stringify({t:Date.now(), s:sold, i:img, o:own, m:pm, v:vp, p:pr})); } catch (e) {}
      })
      .catch(function(){ known = false; });
  }

  function out(id){ return !!(known && id && sold[id]); }
  /* Усі ID варіантів, які згадує опція: поле variant і числа з тексту
     variantFn (там вибір за призначенням, дахом, кольором чи тарифом). */
  function idsOf(o){
    var ids = [];
    if (o.variant) ids.push(o.variant);
    if (typeof o.variantFn === "function"){
      (String(o.variantFn).match(/\b\d{13,15}\b/g) || []).forEach(function(x){ ids.push(+x); });
    }
    return ids;
  }
  /* Опція зникає, коли всі її варіанти відсутні. Коли відсутня лише частина
     (наприклад, одна ціна з двох), рушій відфільтрує її під час вибору. */
  function gone(o){ return safe(function(){ var ids = idsOf(o); return ids.length > 0 && ids.every(out); }, false); }
  function partsGone(get){ return safe(function(){ var parts = typeof get === "function" ? get() : get; return (parts || []).some(function(x){ return !x.corpus && x.variant && out(x.variant); }); }, false); }

  /* Одна зламана опція в даних не має ламати сторінку: перевірку кожної
     обгортаємо, і при помилці опцію лишаємо як є. */
  function safe(fn, fallback){ try { return fn(); } catch (e) { return fallback; } }
  function prune(cfg){
    return safe(function(){ return pruneRaw(cfg); }, false);
  }
  function pruneRaw(cfg){
    if (!known || !cfg || !cfg.CONFIG) return false;
    var changed = false;
    var steps = cfg.CONFIG.steps || [];
    var byH = {};
    steps.forEach(function(s){ byH[s.handle] = s; });

    steps.forEach(function(s){
      if (s.plans){
        var keep = s.plans.filter(function(p){ return !out(p.variant); });
        if (keep.length !== s.plans.length && keep.length){ s.plans.length = 0; Array.prototype.push.apply(s.plans, keep); changed = true; }
      }
      if (!s.options) return;
      var opts = s.options.filter(function(o){ return !gone(o); });
      if (opts.length !== s.options.length && opts.length){
        s.options.length = 0; Array.prototype.push.apply(s.options, opts); changed = true;
        var has = function(h){ return s.options.some(function(o){ return o.handle === h; }); };
        if (Array.isArray(s.def)) s.def = s.def.filter(has);
        else if (s.def != null && !has(s.def)) s.def = s.options[0].handle;
      }
    });
    /* 24.09.2026: Adaptis Amulet розпроданий: питання про нього не ставимо
       зовсім, а не лишаємо сам варіант «Не потрібен». */
    var am = byH.amulet;
    if (am && am.options){
      var amYes = am.options.filter(function(o){ return o.handle === "yes"; })[0];
      if (!amYes || gone(amYes)){
        am.when = function(){ return false; };
        am.def = null;
        changed = true;
      } else if (amYes.variantFn && idsOf(amYes).some(out) && !amYes.__lockPurpose){
        /* 24.09.2026, ніч: немає лише одного варіанта (зараз цивільного, а
           для Сил Оборони є). Картка блокується тільки тоді, коли обрана
           ціна саме того варіанта, якого немає, і пояснює, як його отримати.
           Коли варіант з'явиться, правило зникне саме. */
        amYes.__lockPurpose = true;
        var desc0 = amYes.desc;
        var curOut = function(){ return safe(function(){ return out(amYes.variantFn()); }, false); };
        Object.defineProperty(amYes, "stock", { configurable: true, get: function(){ return curOut() ? 0 : undefined; } });
        Object.defineProperty(amYes, "desc", { configurable: true, get: function(){
          return curOut() ? "Для цивільного використання тимчасово немає в наявності. Доступний для Сил Оборони: увімкніть «Ціна для Сил Оборони України»." : desc0;
        } });
        changed = true;
      }
    }
    /* Тариф підписки: крок subplan тримає ті самі ключі, що й plans. */
    var sub = byH.sub, sp = byH.subplan;
    if (sub && sub.plans && sp){
      var ok = sub.plans.map(function(p){ return p.h; });
      var o2 = sp.options.filter(function(o){ return ok.indexOf(o.handle) > -1; });
      if (o2.length !== sp.options.length && o2.length){ sp.options.length = 0; Array.prototype.push.apply(sp.options, o2); if (ok.indexOf(sp.def) < 0) sp.def = ok[0]; changed = true; }
    }
    /* Колір корпусу: ховаємо, коли його варіанта немає ні для цивільних, ні для Сил Оборони. */
    if (cfg.BASE && byH.color){
      byH.color.options.forEach(function(o){
        var c = cfg.BASE.civil && cfg.BASE.civil[o.handle], d = cfg.BASE.defense && cfg.BASE.defense[o.handle];
        if (c && d && c[0] && d[0] && out(c[0]) && out(d[0])){
          var prev = o.hideWhen;
          o.hideWhen = function(){ return true; };
          if (!prev) changed = true;
        }
      });
    }
    /* Питання концепту SIMPLE: варіант зникає, якщо бракує хоч однієї
       позиції (parts) або крок, який він ставить (set), лишився без опції. */
    if (cfg.SIMPLE){
      Object.keys(cfg.SIMPLE).forEach(function(k){
        var Q = cfg.SIMPLE[k];
        if (!Q || !Q.options) return;
        var keep = Q.options.filter(function(o){
          if (partsGone(function(){ return o.parts; })) return false;
          return Object.keys(o.set || {}).every(function(sk){
            var st = byH[sk];
            if (!st || !st.options) return true;
            return [].concat(o.set[sk]).every(function(h){ return st.options.some(function(x){ return x.handle === h; }); });
          });
        });
        if (keep.length !== Q.options.length && keep.length){
          Q.options.length = 0; Array.prototype.push.apply(Q.options, keep); changed = true;
          if (Q.def && !keep.some(function(o){ return o.h === Q.def; })) Q.def = keep[0].h;
        }
      });
    }
    /* Комплектації: набір із відсутнім товаром не пропонуємо. */
    ["PACKS", "BUNDLES"].forEach(function(n){
      var L = cfg[n];
      if (!Array.isArray(L)) return;
      var keep = L.filter(function(p){
        if (partsGone(function(){ return p.parts; })) return false;
        if (p.kit && p.kit.variant && out(p.kit.variant)) return false;
        return true;
      });
      if (keep.length !== L.length && keep.length){ L.length = 0; Array.prototype.push.apply(L, keep); changed = true; }
    });
    return changed;
  }

  /* Фото з каталогу. Змінює лише рядкові імена файлів у полі img; адреси
     теми (Adaptis Amulet, інвертор) і позиції без варіанта не чіпає. Для
     опції з variantFn фото рахується в момент показу, як і сам варіант. */
  function isFile(x){ return typeof x === "string" && x && !/^(https?:)?\/\//.test(x); }
  function syncImages(cfg){
    var p = syncPrices(cfg);
    return safe(function(){ return syncRaw(cfg); }, false) || p;
  }

  /* Ціни з каталогу, див. опис угорі. Міняє лише звичайні числові поля:
     ціни-функції (тарифи на кілька місяців, монтаж із пластинами) рахуються
     з уже оновлених позицій у момент показу, а геттери Adaptis Amulet беруть
     ціну з каталогу самі. Позиції без товару в каталозі (інвертор, блок
     12-56V) лишаються з записаною ціною. */
  function syncPrices(cfg){
    return safe(function(){ return pricesRaw(cfg); }, false);
  }
  function pricesRaw(cfg){
    if (!known || !cfg) return false;
    var changed = false, seen = [];
    function num(o, k){
      var d = Object.getOwnPropertyDescriptor(o, k);
      return d && "value" in d && d.writable !== false && typeof d.value === "number" ? d : null;
    }
    function set(o, k, v){ if (o[k] !== v){ o[k] = v; changed = true; } }
    /* Набори: price і variant з однаковою будовою, {civil:{white:…}, defense:{…}}. */
    function pair(price, variant){
      Object.keys(price).forEach(function(k){
        var p = price[k], v = variant[k];
        if (typeof v === "number" && pr[v] && num(price, k)) set(price, k, pr[v][0]);
        else if (p && v && typeof p === "object" && typeof v === "object") pair(p, v);
      });
    }
    function fix(o){
      var dv = Object.getOwnPropertyDescriptor(o, "variant"), dp = Object.getOwnPropertyDescriptor(o, "price");
      if (!dv || !dp || !("value" in dv) || !("value" in dp)) return;
      var v = dv.value, p = dp.value;
      if (typeof v === "number" && typeof p === "number"){
        var x = pr[v];
        if (!x || dp.writable === false) return;
        set(o, "price", x[0]);
        var dc = Object.getOwnPropertyDescriptor(o, "compare");
        if (dc && "value" in dc && dc.writable !== false) set(o, "compare", x[1] > x[0] ? x[1] : null);
      } else if (p && v && typeof p === "object" && typeof v === "object") pair(p, v);
    }
    function walk(o){
      if (!o || typeof o !== "object" || seen.indexOf(o) > -1) return;
      seen.push(o);
      if (Array.isArray(o)){
        /* Корпус: BASE[призначення][колір] = [variant, ціна]. */
        if (o.length === 2 && typeof o[0] === "number" && o[0] > 1e10 && typeof o[1] === "number" && pr[o[0]]) set(o, 1, pr[o[0]][0]);
      } else fix(o);
      Object.keys(o).forEach(function(k){
        var d = Object.getOwnPropertyDescriptor(o, k);
        if (d && "value" in d && d.value && typeof d.value === "object") walk(d.value);
      });
    }
    walk(cfg.CONFIG); walk(cfg.BUNDLES); walk(cfg.PACKS); walk(cfg.TERMINAL); walk(cfg.SIMPLE); walk(cfg.PARTS); walk(cfg.BASE);
    return changed;
  }
  function syncRaw(cfg){
    if (!known || !cfg) return false;
    var changed = false, seen = [];
    function fix(o){
      var d = Object.getOwnPropertyDescriptor(o, "img");
      if (!d || !("value" in d) || !isFile(d.value)) return;
      if (typeof o.variantFn === "function"){
        var orig = d.value;
        Object.defineProperty(o, "img", { configurable: true, enumerable: true, get: function(){
          return safe(function(){ return img[o.variantFn()]; }, "") || orig;
        } });
        changed = true;
      } else if (o.variant && img[o.variant] && img[o.variant] !== d.value){
        o.img = img[o.variant];
        changed = true;
      }
    }
    function walk(o){
      if (!o || typeof o !== "object" || seen.indexOf(o) > -1) return;
      seen.push(o);
      if (!Array.isArray(o)) fix(o);
      Object.keys(o).forEach(function(k){
        var d = Object.getOwnPropertyDescriptor(o, k);
        if (d && "value" in d && d.value && typeof d.value === "object") walk(d.value);
      });
    }
    walk(cfg.CONFIG); walk(cfg.BUNDLES); walk(cfg.PACKS); walk(cfg.TERMINAL); walk(cfg.SIMPLE); walk(cfg.PARTS);
    /* Галерея сторінки термінала: усі фото товару-термінала в порядку адмінки. */
    var T = cfg.TERMINAL, M = cfg.MEDIA;
    /* 07.10.2026: поки галерею зібрано в темі (ADAPTIS_ASSETS.mediaLock: картки товару лежать
       у файлах теми, а не у фото товару), каталог її не переписує. */
    if (T && T.variant && Array.isArray(M) && !(window.ADAPTIS_ASSETS || {}).mediaLock){
      var list = pm[vp[T.variant]] || [];
      if (list.length && list.join("|") !== M.join("|")){ M.length = 0; Array.prototype.push.apply(M, list); changed = true; }
    }
    /* Кольори корпусу: фото варіанта, лише якщо воно призначене в адмінці. */
    var CM = cfg.COLOR_MEDIA, B = cfg.BASE && cfg.BASE.civil;
    if (CM && B){
      Object.keys(CM).forEach(function(c){
        var id = B[c] && B[c][0], f = id && own[id] && img[id];
        if (f && Array.isArray(CM[c]) && CM[c][0] !== f){
          var rest = CM[c].filter(function(x){ return x !== f; });
          CM[c].length = 0; CM[c].push(f); Array.prototype.push.apply(CM[c], rest);
          changed = true;
        }
      });
    }
    return changed;
  }

  /* Фото варіанта з каталогу (ім'я файлу, як у даних конструктора), або "". */
  function imgOf(id){ return (known && id && img[id]) || ""; }

  /* Ціна варіанта з каталогу в копійках, або 0. */
  function priceOf(id){ return (known && id && pr[id] && pr[id][0]) || 0; }
  /* 28.09.2026: стара ціна варіанта з каталогу, лише коли вона більша за ціну. */
  function compareOf(id){ var x = known && id && pr[id]; return (x && x[1] > x[0]) ? x[1] : 0; }

  window.AdaptisStock = { ready: ready, out: out, prune: prune, syncImages: syncImages, syncPrices: syncPrices, imgOf: imgOf, priceOf: priceOf, compareOf: compareOf, known: function(){ return known; } };
})();
